<template>
    <div>
        <div class="back border-bottom" @click="back">
            <i class="iconfont">&#xe604;</i>
        </div>
        <div class="notification">
            <h3>消费者告知书</h3>
            <div class="mess">
                <p>尊敬的客户：</p>
                <p>您好！为帮助您更好地选购易货商品，请您在购买前务必认真、详细阅读并完全理解本告知书的全部内容，并对自身风险承担做出客观判断。同意本告知书内容后再下单购买：</p>
                <p>1.您在爱易货网平台上购买的易货商品，均为爱易货网“自营易货商品”，商品本身为爱易货交易采购的商品。</p>
                <p>2.每款产品均由商家提供合格合法的经营手续及证件。</p>
                <p>3.爱易货网平台为平台经营者，商品均平台向您提供，爱易货网平台自营易货商品一但销售，不提供退换货服务。</p>
                <p>4.为了方便您对易货电商模式的理解，可前往爱易货网平台公司了解更多详情。</p>
                <p>爱易货网平台专注易货贸易，严控每一个环节，为顾客提供易货服务。</p>
            </div>
            <p class="thanks">谢谢！</p>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ConsumeMess',
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped>
.back{ padding: 10px 15px;}
.iconfont{ font-size: 26px;}
.notification{ padding: 10px 15px;}
.notification h3{ text-align: center; font-weight: 800; font-size: 16px;}
.mess p{ line-height: 25px; font-size: 14px;}
.thanks{ margin: 20px 0 0;}
</style>



// WEBPACK FOOTER //
// src/pages/consume/components/Mess.vue